import { BlogPost } from './types';

export const seoBlogPosts: BlogPost[] = [
];



